import { createUseStyles } from 'react-jss'
import { colors } from '../../variables.style'

const hpad = '6px'
const vpad = '3px'

export const style = {
  link: {
    height: '24px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end'
  },
  linkIcon: {
    display: 'inline-block',
    verticalAlign: 'middle',
    marginLeft: '10px',
    fontSize: 18,
    lineHeight: 1
  },
  narrativeMarkdown: {
    margin: '0 23px',
    maxWidth: '1024px',
    alignSelf: 'center',
    overflowX: 'scroll',
    textAlign: 'left',
    '& button': {
      marginBottom: '12px',
      padding: '0px 12px',
      color: 'white',
      fontSize: '12px'
    },
    '& .narrative-element': {
      margin: '48px auto'
    },
    '& table': {
      margin: '8px auto',
      borderCollapse: 'collapse',
      borderSpacing: '0'
    },
    '& img': {
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    '& p': {
      margin: '8px 10%',
      fontSize: '1.2em',
      textIndent: '2em'
    },
    '& h1, h2, h3, h4, h5, h6': {
    },
    '& h1': {
      marginBottom: '24px'
    },
    '& thead tr': {
      borderTop: `1px solid ${colors.borderGray}`,
      borderBottom: `2px solid ${colors.borderGray}`
    },
    '& th, td': {
      fontSize: '0.9em',
      padding: `${vpad} ${hpad}`
    },
    '& th': {
      borderTop: '1px solid #b2b2b2',
      borderBottom: '2px solid #b2b2b2'
    }
  }
}

export const useStyles = createUseStyles(style)
